import React, { ReactElement, useState } from 'react';
import styled from 'styled-components';
// import ReactIcon from '@mdi/react';
// import { mdiChevronDown } from '@mdi/js';

import { useAuth } from 'features/auth';
import { ButtonIcon, Flex, Icons, Typography } from 'components';
import { Link } from 'react-router-dom';
import { createUrl } from 'app/utils';
import { useTracking } from 'features/tracking';
import { useSchool } from 'features/school';
import { useResources } from 'features/resources';

const MenuArrow = styled('i')`
  content: '';
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid ${({ theme }) => theme.colors.gray_100};
  position: absolute;
  top: -8px;
  right: 15px;
`;

const CustomLink = styled(Link)`
  flex-grow: 1;
  white-space: nowrap;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray_300};
  color: ${({ theme }) => theme.colors.black80};

  &:hover {
    color: ${({ theme }) => theme.colors.primary_contrast};
    background: ${({ theme }) => theme.colors.primary_400};

    ${MenuArrow} {
      border-bottom: 8px solid ${({ theme }) => theme.colors.primary_400};
    }
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 0;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      padding: 15px;

      ${mediaQueries.desktop} {
        padding: 20px;
      }
    `;
  }}
`;

const MenuWrapper = styled(Flex)`
  position: absolute;
  background: ${({ theme }) => theme.colors.gray_100};
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  z-index: 1001;

  ${({ theme: { mediaQueries } }) => {
    return `
      top: calc(100% + 15px);
      right: -14px;

      ${mediaQueries.desktop} {
        top: calc(100% + 5px);
        right: 0px;
      }
    `;
  }}
`;

const Wrapper = styled(Typography)`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  user-select: none;

  .greeting {
    color: white;
    padding-right: 5px;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      padding: 0;

      ${mediaQueries.desktop} {
        padding: 10px 12px 10px 0;
      }
    `;
  }}
`;

const Icon = styled(Icons)`
  width: 24px;
  color: ${({ theme }) => theme.colors.primary_400};
  margin-left: 5px;
`;

const MenuUser = (): ReactElement => {
  const [menuOpened, setMenuOpened] = useState(false);
  const { fullName, sso } = useAuth();
  const { eventTracker } = useTracking();
  const { schoolUuid } = useSchool();
  const {
    schools: { schoolXp, schoolTestSchool },
  } = useResources();

  const isBenndorf = schoolUuid === 'cfaf550b-037d-45b2-9f84-979fb01185d4';
  const isMeuPlanoCrypto = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';

  let menuProductsLabel = 'Meus cursos';
  if (isBenndorf) {
    menuProductsLabel = 'Meus produtos';
  } else if (isMeuPlanoCrypto) {
    menuProductsLabel = 'Painel';
  }

  const name = fullName ? fullName.split(' ') : [];

  return name.length ? (
    <Wrapper type="type2" color="primary_200" fontWeight="bold" upper>
      <Flex onClick={() => setMenuOpened(!menuOpened)} display={{ m: 'none', d: 'flex' }} alignItems="center">
        <span className="greeting">Olá,</span> {`${name.shift()} ${name.pop()}`}
        <Icon icon="chevronDown" />
      </Flex>

      <Flex display={{ m: 'flex', d: 'none' }} alignItems="center">
        <ButtonIcon onClick={() => setMenuOpened(!menuOpened)} icon="account" bg="transparent" color="primary_400" />
      </Flex>

      {menuOpened && (
        <MenuWrapper onClick={() => setMenuOpened(!menuOpened)}>
          <CustomLink to={createUrl('myCourses')}>
            <MenuArrow />
            {menuProductsLabel}
          </CustomLink>

          {/* <CustomLink to={createUrl('myBadges')}>Minhas conquistas</CustomLink> */}

          {schoolXp ? (
            <>
              <CustomLink to={createUrl('changePassword')}>Alterar senha</CustomLink>
            </>
          ) : (
            <>{!sso && <CustomLink to={createUrl('account')}>Dados pessoais</CustomLink>}</>
          )}
          {}

          {schoolTestSchool ? (
            <>
              <CustomLink to={createUrl('account/certificates')}> Certificados</CustomLink>
              <CustomLink to={createUrl('account/messages')}>Mensagens</CustomLink>
              <CustomLink to={createUrl('account/documents')}>Documentos acadêmicos</CustomLink>
              <CustomLink to={createUrl('account/classdiary')}>Diário de Classe</CustomLink>
            </>
          ) : null}

          <CustomLink
            onClick={() => {
              eventTracker({
                category: 'Usuário',
                action: 'Logout',
                label: 'Menu do usuário',
              });
            }}
            to={createUrl('logout')}
          >
            Sair
          </CustomLink>
        </MenuWrapper>
      )}
    </Wrapper>
  ) : (
    <></>
  );
};

export default MenuUser;
